import { render, staticRenderFns } from "./PartnersWrapper.vue?vue&type=template&id=6dc7687c"
import script from "./PartnersWrapper.vue?vue&type=script&lang=ts"
export * from "./PartnersWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports